module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/027-american-samoa-2490ef442e7976648f4d0a174728f25f.svg";